import Vue from 'vue'
import App from './layouts/App'
import { createStore } from './store/index'
import { createRouter } from './router/index'
import vuetify from './vuetify'


export function createApp (ctx = false) {
  const router = createRouter()
  const store = createStore()

  const app = new Vue({
    router,
    store,
    vuetify,
    ...App,
  
    mounted () {
      if(!ctx) {
        this.$store.commit('templateLoad')

        let token = window.localStorage.getItem('token')
        if(token) {
          this.$store.commit('Auth', token)
        }
    
        window.addEventListener('eventBus', (e) => { 
    
          if(e.detail.event === "link") {
            this.$router.push(e.detail.data)
          }
    
          if(e.detail.event === "modal") {
            let modal = e.detail.data;
            if(modal === 'dialogСallDoctor') this.$root.$refs.mod.dialogСallDoctor = true
            if(modal === 'dialog') this.$root.$refs.mod.dialog = true
            if(modal === 'dialogСall') this.$root.$refs.mod.dialogСall = true
            if(modal === 'dialogMap') this.$root.$refs.mod.dialogMap = true
            if(modal === 'dialogСallCons') this.$root.$refs.mod.dialogСallCons = true
            if(modal === 'dialogOnPrice') this.$root.$refs.mod.dialogOnPrice = true
            if(modal === 'dialogEdit') this.$root.$refs.mod.dialogEdit = true
          }
        }, false)

        this.$store.dispatch('fetchCity')
        this.$store.dispatch('fetchTemplate').then(() => {
          this.$store.commit('isTemplateLoad')
        })

        this.$store.dispatch('Auth')
      }
    },
    methods: {
      exit() {
        if(!ctx) {
          window.localStorage.removeItem('token')
          this.$store.commit('Auth', null)
        }
      }
    }
  })
  return { app, router, store }
}




// WEBPACK FOOTER //
// ./src/app.js